import React from "react";
import StepIndicator from "../stepIndicator/StepIndicator";

/**
 * OnboardingStepper — thin wrapper around the shared StepIndicator.
 * Keeps the same props API so OnboardingWizard doesn't need changes.
 */
const OnboardingStepper = ({ steps, currentStep, onStepClick }) => {
  return (
    <StepIndicator
      steps={steps}
      currentStep={currentStep}
      onStepClick={onStepClick}
    />
  );
};

export default OnboardingStepper;
